import { GoogleOAuthProvider } from '@react-oauth/google';
import { LoginButton } from './LoginButton';
import { Button } from '@mui/material';
const GoogleLoginButton = (props) => {
const CLIENTID = import.meta.env.VITE_VERCEL_CLIENT_ID_GOOGLE
  if (!CLIENTID) {
    return (
      <Button
        variant={props.variant || 'contained'}
        startIcon={props.startIcon}
        endIcon={props.endIcon}
        disabled
        sx={{
          width: '244px',
          ...(props.buttonSx || {}),
          opacity: 0.65,
          '&.Mui-disabled': {
            color: props.buttonSx?.color || 'inherit',
            borderColor: props.buttonSx?.borderColor || undefined,
            backgroundColor: props.buttonSx?.backgroundColor || undefined,
          },
        }}
      >
        {props.children || 'Google'}
      </Button>
    );
  }
  return (
    <GoogleOAuthProvider clientId={CLIENTID}>
      <LoginButton {...props} />
    </GoogleOAuthProvider>

  );
};

export default GoogleLoginButton;
